import { Injectable } from '@angular/core';
import { ApiService } from '@xref/ngx';
import { map } from 'rxjs/operators';

export class MarketingLeadData {
  phone: string;
  organisation: string;
  annual_hires: number;
  industry: number;
}

@Injectable({
  providedIn: 'root'
})
export class MarketingLeadService {
  constructor(
    private api: ApiService
  ) {}

  // Pre populates form fields on marketing lead form
  getPrePop() {
    return this.api.get('v1/marketing-lead').pipe(map(data => data));
  }

  saveLead(formData: MarketingLeadData) {
    return this.api.post('v1/marketing-lead', formData).pipe(map(data => data));
  }
}
